import React, { useState, useRef, Fragment } from 'react';
import { useTranslate, Button } from 'react-admin';
import { Dialog, DialogTitle, DialogContent, Button as MuiButton, Box } from '@material-ui/core';
import IconCancel from '@material-ui/icons/Cancel';
import IconSave from '@material-ui/icons/Save';

const BaseDialog = ({ icon, buttonDisabled, buttonLabel, handleSubmit, children, dialogTitle }) => {
	const [showDialog, setShowDialog] = useState(false);
	const dialogContentRef = useRef();
	const translate = useTranslate();
	const handleSaveClick = () => {
		// https://github.com/final-form/react-final-form/blob/master/docs/faq.md#via-documentgetelementbyid
		const form = dialogContentRef.current.getElementsByTagName('form')[0];
		if (form) {
			form.dispatchEvent(new Event('submit', { cancelable: true }));
		} else {
			setShowDialog(false);
		}
	}
	const hideDialog = () => {
		setShowDialog(false);
	}
	return (
		<Fragment>
			<Button
				disabled={buttonDisabled}
				onClick={() => setShowDialog(true)}
				label={buttonLabel}
			>
				{icon}
			</Button>
			<Dialog	fullWidth open={showDialog} onClose={() => setShowDialog(false)}>
				<DialogTitle>{dialogTitle}</DialogTitle>
				<DialogContent ref={dialogContentRef}>
					{children({ handleSubmit, hideDialog })}
					<Box display="flex" justifyContent="space-between" width="100%" style={{ paddingBottom: 16 }}>
						<MuiButton variant="contained" color="primary" disableElevation startIcon={<IconSave />} onClick={handleSaveClick}>
							{translate('coreWalletAdmin.common.saveButton')}
						</MuiButton>
						<MuiButton variant="contained" disableElevation startIcon={<IconCancel />} onClick={() => setShowDialog(false)}>
							{translate('coreWalletAdmin.common.cancelButton')}
						</MuiButton>
					</Box>
				</DialogContent>
			</Dialog>
		</Fragment>
	);
};

export default BaseDialog;
